import { Body, H1 } from "@datapay-by-datacom/design-system";
import { BatchList } from "../components/BatchList/BatchList";
import { useShadowRunAgentId } from "../hooks/useShadowRunAgentId";
import styles from "./DashboardScreen.module.css";

export function DashboardScreen() {
  const {
    agentId,
    isConfigured,
    isLoading: isAgentConfigLoading,
  } = useShadowRunAgentId();

  return (
    <div className={styles.container}>
      <H1>Shadow Runs</H1>

      <Body>
        Compare payroll calculations between FSC and Pacific Pay to validate
        migration accuracy across your organisations.
      </Body>

      {isAgentConfigLoading && <Body>Loading configuration…</Body>}

      {!isAgentConfigLoading && !isConfigured && (
        <Body>
          Shadow run agent is not configured for this environment.
        </Body>
      )}

      {!isAgentConfigLoading && isConfigured && agentId && (
        <BatchList agentId={agentId} />
      )}
    </div>
  );
}
